
import { Component, Vue } from 'vue-property-decorator'
import { getToken } from '@/utils/cookies'
import request from '@/utils/request'

@Component({
  name: 'WebhookLogs'
})
export default class extends Vue {
  private listLoading = false
  private logs: any[] = []
  private total = 0
  private statistics: any[] = []
  private startDate = ''
  private endDate = ''
  private rawDataDialogVisible = false
  private selectedLog: any = {}

  private listQuery = {
    page: 1,
    limit: 50,
    platform: ''
  }

  created() {
    const end = new Date()
    const start = new Date()
    start.setDate(start.getDate() - 7)
    this.startDate = start.toISOString().split('T')[0]
    this.endDate = end.toISOString().split('T')[0]
    this.loadLogs()
  }

  private formatDate(dateStr: string): string {
    if (!dateStr) return 'N/A'
    const date = new Date(dateStr)
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    return `${day}.${month}.${year} ${hours}:${minutes}`
  }

  get formattedRawData(): string {
    try {
      return JSON.stringify(this.selectedLog.data, null, 2)
    } catch {
      return 'Unable to parse data'
    }
  }

  private async loadLogs() {
    this.listLoading = true
    try {
      const params: any = {
        page: this.listQuery.page,
        limit: this.listQuery.limit
      }

      if (this.startDate) {
        params.startDate = this.startDate
      }
      if (this.endDate) {
        params.endDate = this.endDate
      }
      if (this.listQuery.platform) params.platform = this.listQuery.platform

      const response: any = await request({
        url: '/admin/subscription/logs',
        method: 'get',
        params,
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      })

      // Handle both response formats (response.data.success or response.success)
      const res = response.data || response
      if (res.success) {
        this.logs = res.data
        this.total = res.pagination.total
        this.statistics = res.statistics.byPlatform || []
      }
    } catch (error) {
      console.error('Failed to load logs:', error)
      this.$message.error('Failed to load webhook logs')
    } finally {
      this.listLoading = false
    }
  }

  private handleFilter() {
    this.listQuery.page = 1
    this.loadLogs()
  }

  private handleRefresh() {
    this.loadLogs()
  }

  private handleSizeChange(val: number) {
    this.listQuery.limit = val
    this.loadLogs()
  }

  private handleCurrentChange(val: number) {
    this.listQuery.page = val
    this.loadLogs()
  }

  private showRawData(row: any) {
    this.selectedLog = row
    this.rawDataDialogVisible = true
  }

  private copyData(row: any) {
    const text = JSON.stringify(row.data, null, 2)
    navigator.clipboard.writeText(text).then(() => {
      this.$message.success('Copied to clipboard')
    }).catch(() => {
      this.$message.error('Failed to copy')
    })
  }

  private copyRawData() {
    navigator.clipboard.writeText(this.formattedRawData).then(() => {
      this.$message.success('Copied to clipboard')
    }).catch(() => {
      this.$message.error('Failed to copy')
    })
  }
}
